import { Link } from "react-router-dom";
import { SITE } from "@/constants/testIds";
import { SECTIONS } from "@/lib/sections";

export function SiteFooter() {
  return (
    <footer data-testid={SITE.footer} className="border-t border-kira-border py-12 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2.5 mb-3">
              <div className="flex h-8 w-8 items-center justify-center rounded bg-kira-gold text-black font-chivo font-bold text-sm">K</div>
              <div className="leading-none">
                <p className="font-chivo font-bold text-white text-sm">KIRA Score</p>
                <p className="text-[10px] text-kira-textMuted font-mono tracking-wide mt-0.5">RESEARCH BEFORE RETURNS</p>
              </div>
            </div>
            <p className="text-sm text-kira-textMuted max-w-sm">
              Independent KIRA Score research, published for investors who read before they act.
            </p>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-kira-textMuted mb-3">Research</p>
            <ul className="space-y-2">
              {SECTIONS.map((s) => (
                <li key={s.key}>
                  <Link to={`/research/${s.key}`} className="text-sm text-kira-textMuted hover:text-kira-gold transition-colors">
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-kira-border pt-6">
          <p className="text-xs text-kira-textMuted font-mono">
            © 2026 KIRA Score. Research is for informational purposes only — not investment advice.
          </p>
        </div>
      </div>
    </footer>
  );
}
